var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-box"},[_c('div',{staticClass:"top-wrap"},[_vm._v(" 汇鲜 ")])])}]

export { render, staticRenderFns }